import { forwardRef } from 'react'
import { cn } from '@/lib/utils'
const Kbd = forwardRef(({ className, ...props }, ref) => {
  return (
    <kbd
      className={cn(
        'pointer-events-none inline-flex h-[18px] select-none items-center gap-1 rounded border bg-muted/50 px-1 font-sans text-[10px] font-medium text-muted-foreground/70 opacity-100',
        className,
      )}
      ref={ref}
      {...props}
    />
  )
})
Kbd.displayName = 'Kbd'
const KbdGroup = forwardRef(({ className, children, ...props }, ref) => {
  return (
    <span ref={ref} className={cn('inline-flex items-center gap-1', className)} {...props}>
      {children}
    </span>
  )
})
KbdGroup.displayName = 'KbdGroup'
export { Kbd, KbdGroup }
